import type { AxiosInstance } from 'axios'

import {
  ProductDetailInterface,
  UpdateProductInputInterface
} from '../../interfaces/product'

export const updateProduct = (api: AxiosInstance) => (
  productId: string,
  productDetail: UpdateProductInputInterface
): Promise<ProductDetailInterface> =>
  api.put(`/v1.0/admin/products/${productId}`, productDetail)
